/** 文字轴型 */
<template lang="pug">
.doTEXTAXIS
  .title  {{cont.stem}}
  Timeline
    TimelineItem(v-for='v in JSON.parse(cont.metas)' :key="v").content-li
      div  {{v}}
</template>
<script>
export default {
  props: ["cont"],
  created() {
    console.log(this.cont);
  }
};
</script>
<style lang="stylus" scoped>
.doTEXTAXIS
  width 100%
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI-Bold
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    line-height 25px
    margin-bottom 24px
  .content-li
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 28px
    display flex
    align-items: flex-start;
    .circular
      margin-right 6px
      border 2px solid #4CA990
      width 16px
      height 16px
      border-radius 50%
      display inline-block
      margin-top: 6px;

</style>
